// MapaDireccionEnv.js - VERSIÓN CORREGIDA
import React, { useRef, useEffect, useState } from "react";
import {
  GoogleMap,
  Marker,
  StandaloneSearchBox,
} from "@react-google-maps/api";
import { TextField, Box, InputAdornment, CircularProgress } from "@mui/material";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";

const containerStyle = {
  width: "100%",
  height: "300px",
};

function MapaCoordenadasNew(props) {
  const inputRef = useRef();
  const searchBoxRef = useRef();
  const [googleLoaded, setGoogleLoaded] = useState(false);

  const center = {
    lat: parseFloat(props.datosDir.latitud) || -32.9468,
    lng: parseFloat(props.datosDir.longitud) || -60.6393,
  };

  // ✅ Verificar cuando Google Maps está disponible desde el padre
  useEffect(() => {
    const checkGoogleMaps = () => {
      if (window.google && window.google.maps && window.google.maps.places) {
        setGoogleLoaded(true);
        return true;
      }
      return false;
    };

    if (checkGoogleMaps()) return;

    const interval = setInterval(() => {
      if (checkGoogleMaps()) {
        clearInterval(interval);
      }
    }, 100);

    const timeout = setTimeout(() => {
      clearInterval(interval);
      console.warn('Google Maps loading timeout in MapaDireccionEnv');
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  const handlePlaceChange = () => {
    if (!searchBoxRef.current) return;
    
    const places = searchBoxRef.current.getPlaces();
    if (places && places.length > 0) {
      const place = places[0];
      props.setDatosDir({
        ...props.datosDir,
        direccion_entrega: place.formatted_address,
        latitud: place.geometry.location.lat(),
        longitud: place.geometry.location.lng(),
      });
    }
  };

  // Estilo para autocompletado
  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.innerHTML = `
      .pac-container {
        z-index: 99999 !important;
        position: absolute !important;
      }
    `;
    document.head.appendChild(styleTag);
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  if (!googleLoaded) {
    return (
      <Box 
        width="100%" 
        height="300px" 
        display="flex" 
        justifyContent="center" 
        alignItems="center"
        border="1px solid #ddd"
        borderRadius={1}
      >
        <Box textAlign="center">
          <CircularProgress size={40} sx={{ mb: 1 }} />
          <br />
          Cargando mapa...
        </Box>
      </Box>
    );
  }

  return (
    <Box width="100%">
      <StandaloneSearchBox
        onLoad={(ref) => (searchBoxRef.current = ref)}
        onPlacesChanged={handlePlaceChange}
      >
        <Box mb={1} mt={1} sx={{ position: 'relative', zIndex: 2000 }}>
          <TextField
            inputRef={inputRef}
            label="Buscar Dirección.."
            fullWidth
            placeholder="Dirección"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <TravelExploreIcon color="primary" />
                </InputAdornment>
              ),
            }}
            focused
          />
        </Box>
      </StandaloneSearchBox>

      <Box sx={{ position: 'relative' }}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={15}
        >
          <Marker
            position={center}
            draggable={true}
            onDragEnd={(p) =>
              props.setDatosDir({
                ...props.datosDir,
                latitud: p.latLng.lat(),
                longitud: p.latLng.lng(),
              })
            }
          />
        </GoogleMap>
      </Box>
    </Box>
  );
}

export default MapaCoordenadasNew;